import React from "react";
import { FormProvider } from "../../fluidComponents/fluidForm/FormContext";
import { DocFluidForm } from "../../fluidComponents/fluidForm/DocFluidForm.component";
import { ConfigTransferSection } from '../ConfigTransferSection';
export function BuilderTabContent({ configRecord, onConfigRecordChange }) {
    return (React.createElement(FormProvider, { formInstance: 'formBuilder.formConfig' },
        React.createElement(DocFluidForm, { disableUpdateHighlighting: true, rounded: false, hideInputModes: true, showSubmitButton: false, useUpdateChat: false, onChange: (data) => {
                onConfigRecordChange({
                    formConfig: data
                });
            }, fieldProps: {
                useInstantValidation: false,
                hideHelpButton: true
            } }),
        React.createElement(ConfigTransferSection, { configRecord: configRecord, onConfigRecordChange: onConfigRecordChange })));
}
